import {
  DocumentDetailOfficeDeskConsignmentsComponent
} from './components/document-detail-office-desk-consignments/document-detail-office-desk-consignments.component';
import {
  DocumentDetailOwnConsignmentsComponent
} from './components/document-detail-own-consignments/document-detail-own-consignments.component';
import {
  DocumentDetailRelatedObjectsComponent
} from './components/document-detail-related-objects/document-detail-related-objects.component';
import {
  DocumentDetailActivitiesComponent
} from './components/document-detail-tasks/document-detail-activities.component';
import {NotImplementedComponent} from '|shared';
import {
  DocumentDetailDeliveryComponent
} from './components/document-detail-delivery/document-detail-delivery.component';
import {DocumentDetailHistoryComponent} from './components/document-detail-history/document-detail-history.component';
import {DocumentDetailPreviewComponent} from './components/document-detail-preview/document-detail-preview.component';
import {DocumentDetailComponent} from './document-detail.component';
import {
  ObjectDetailTransferIncidentsComponent
} from '../document-shared/components/object-detail-transfer-incidents/object-detail-transfer-incidents.component';
import {
  DocumentDetailSubjectsComponent
} from './components/document-detail-subjects/document-detail-subjects.component';
import {
  DocumentDetailContractPublicationComponent
} from './components/document-detail-contract-publication/document-detail-contract-publication.component';
import {IczRoutes} from '@icz/angular-application-core';
import {DocumentDetailRoute, SharedRoute} from '|ui-essl-core';

const DOCUMENT_DETAIL_PAGE_NAME: string = 'Detail dokumentu';

export const ROUTES: IczRoutes = [
  {
    path: '',
    title: DOCUMENT_DETAIL_PAGE_NAME,
    component: DocumentDetailComponent,
    children: [
      {
        path: '',
        title: DOCUMENT_DETAIL_PAGE_NAME,
        redirectTo: DocumentDetailRoute.PREVIEW,
        pathMatch: 'full'
      },
      {
        path: DocumentDetailRoute.PREVIEW,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        component: DocumentDetailPreviewComponent,
        data: {
          usesAlias: true
        }
      },
      {
        path: DocumentDetailRoute.DELIVERY,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        component: DocumentDetailDeliveryComponent,
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        },
      },
      {
        path: DocumentDetailRoute.OWN_CONSIGNMENTS,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        component: DocumentDetailOwnConsignmentsComponent,
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        },
      },
      {
        path: DocumentDetailRoute.OFFICE_DESK_CONSIGNMENTS,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        component: DocumentDetailOfficeDeskConsignmentsComponent,
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        },
      },
      {
        path: DocumentDetailRoute.SUBJECTS,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        component: DocumentDetailSubjectsComponent,
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        },
      },
      {
        path: DocumentDetailRoute.RELATED_OBJECTS,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        component: DocumentDetailRelatedObjectsComponent,
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        },
      },
      {
        path: DocumentDetailRoute.HISTORY,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        component: DocumentDetailHistoryComponent,
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        },
      },
      {
        path: DocumentDetailRoute.COMPONENTS,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        },
        loadChildren: () => import('../essl-components-overview/essl-components.routes'),
      },
      {
        path: DocumentDetailRoute.ACTIVITIES,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        component: DocumentDetailActivitiesComponent,
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        },
      },
      {
        path: DocumentDetailRoute.SHARE,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        loadChildren: () => import('./components/document-detail-permission-settings/document-detail-permission-settings.routes'),
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        },
      },
      {
        path: DocumentDetailRoute.INCIDENTS,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        component: ObjectDetailTransferIncidentsComponent,
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        }
      },
      {
        path: DocumentDetailRoute.CONTRACT_PUBLICATION,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        component: DocumentDetailContractPublicationComponent,
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        }
      },
      {
        path: SharedRoute.NOT_IMPLEMENTED,
        title: DOCUMENT_DETAIL_PAGE_NAME,
        component: NotImplementedComponent,
        data: {
          fallbackBreadcrumbUri: DocumentDetailRoute.PREVIEW,
          usesAlias: true,
        },
      },
    ],
  },
];
